import 'magnific-popup';

export default async () => {
    let $categorydropdown = $( '.has-child > .header__menu-link' );
    let $bodyClass = $( 'body' );

    $(document).ready(function() {
        // get the page from the url, without possible attributes after the '?'
        const siteUrl = $(location).attr('href');
        const page = siteUrl.split('/')[3]?.split('?')[0];
        if (page) {
            const activePageSelectors = {
                'services': '.header__menu-link[href="#"]',
                'woonreis': '.header__menu-link[href="#"]',
                'expert-in-de-buurt': '.header__menu-link[href="/experts"]',
                'default': '.header__menu-link[href="/' + page + '"]'
            };
            const activePage = $(activePageSelectors[page] || activePageSelectors['default']);
            activePage.parent().addClass('is-active');
        }
    });

    $categorydropdown.click( function ( e ) {
        e.preventDefault();
        const $header = $('.header');

        if ($header.hasClass('is-menu-open')) {
            $header.removeClass('is-menu-open');
            $(this).parent().removeClass('submenu-visible');
        } else {
            $header.addClass('is-menu-open');
            $(this).parent().addClass('submenu-visible');
        }
    });

    $( '.js-toggle-menu' ).click( function ( e ) {
        e.preventDefault();
        $bodyClass.toggleClass( 'is-open-menu' );
        $bodyClass.removeClass( 'is-open-search' );
    } );

    $( '.js-toggle-search' ).click( function ( e ) {
        e.preventDefault();
        $bodyClass.toggleClass( 'is-open-search' );
        $bodyClass.removeClass( 'is-open-menu' );
    } );

    $( '.js-toggle-close' ).click( function ( e ) {
        e.preventDefault();
        $bodyClass.removeClass( 'is-open-menu' );
        $bodyClass.removeClass( 'is-open-search' );
    } );

    let headerLogo = $( '.header__logo img' );
    headerLogo.attr( 'alt', 'Nieuw Wonen Nederland' );

    $( '.js-gallery-btn' ).click( function ( e ) {
        e.preventDefault();
        $bodyClass.toggleClass( 'is-open-gallery' );
    } );

    if ( $( '.hero, .landing-banner' ).length ) {
        $( '.header' ).addClass( 'header--light' );
    }

    if ( $( '.not-found' ).length ) {
        $( '.header' ).addClass( 'header--light-mobile' );
    }

    if ( $( '.search-heading, .heading--search, .step-heading' ).length ) {
        $( '.header' ).addClass( 'header--search' );
    }

    $( '.header__menu-inner > ul > li > .header__submenu' ).parent( 'li' ).addClass( 'has-child' );

    $( '.header__menu-inner > ul > .has-child > a' ).append().after( '<span class=\'header__arrow d-xl-none js-menu-toggle\'><i class=\'icon-chevron-down\'></i></span>' );

    $( '.js-menu-toggle' ).click( function ( e ) {
        e.preventDefault();

        let $this = $( this );

        if ( $this.hasClass( 'is-active' ) ) {
            $this.removeClass( 'is-active' );
            $this.next().slideUp( 350 );
        } else {
            $this.parent().parent().find( '.js-menu-toggle' ).removeClass( 'is-active' );
            $this.parent().parent().find( '.has-child .header__submenu' ).slideUp( 350 );
            $this.toggleClass( 'is-active' );
            $this.next().slideToggle( 350 );
        }
    } );

    $( '.js-popup-modal' ).magnificPopup( {
        type: 'inline',
        preloader: false,
        mainClass: 'mfp-popup',
        closeOnBgClick: false,
        callbacks: {
            open: function() {
                // Bind mousedown event to document to detect mousedown events
                $(document).on('mousedown', function(event) {
                    // Check if the clicked element is outside the popup
                    if (!$(event.target).closest('.popup-bg').length) {
                        // Close the popup
                        $.magnificPopup.close();
                    }
                });
            },
            close: function() {
                // Unbind mousedown event when the popup is closed
                $(document).off('mousedown');

                if (this?.items && this?.items[0]?.src === '#user-profile-popup') {
                    location.reload();
                }
            }
        }
    } );

    const magnificPopupSelectors = 'a[href="#register-popup"], ' +
        'a[href="#login-popup"], ' +
        'a[href="#logout-popup"], ' +
        'a[href="#forgotpassword-popup"], ' +
        'a[href="#contact-popup"], ' +
        'a[href="#newslettersubscription-popup"]' +
        'a[href="#newslettersubscription-popup"]'

    $(document).on('click', magnificPopupSelectors, function() {
        $.magnificPopup.open({
            items: {
                src: this.getAttribute('href')
            },
            type: 'inline',
            preloader: false,
            callbacks: {
                open: () => {
                    const redirect = this.getAttribute('data-redirect')
                    if (redirect) {
                        const input = '<input type="hidden" name="redirect" value="' + redirect + '" />'
                        document.querySelector(this.getAttribute('href')).querySelector('form').insertAdjacentHTML('beforeend', input)
                    }
                },
                close: () => {
                    // ajax calls may modify the content of a modal. Reset this on closing so the next time it's opened, it won't continue
                    document.querySelectorAll('[data-original-content]').forEach((element) => {
                        element.innerHTML = element.dataset.originalContent
                        delete element.dataset.originalContent
                    })
                }
            }
        })
    })

    $( '.js-popup-video' ).magnificPopup( {
        disableOn: 700,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
    } );

    $( document ).on( 'keydown', '.popup-modal-dismiss', function ( e ) {
        e.preventDefault();
        $.magnificPopup.close();
    } );

    let cancelLogoutModalButton = $('#close-logout-modal-button');
    cancelLogoutModalButton.on('click', function () {
        $.magnificPopup.close();
    });
};
